import { render, staticRenderFns } from "./UserChangePassword.vue?vue&type=template&id=59c06aa6"
import script from "./UserChangePassword.vue?vue&type=script&lang=ts"
export * from "./UserChangePassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports